export default {
    TRACKED_LINK_PLACEHOLDER: "[tracked-link]",
    REVEIW_LOCATION_LINK_PLACEHOLDER: "[review-location-link]"
}